// extracted by mini-css-extract-plugin
module.exports = {"button":"e_9h","inner":"e_-h","innerText":"e_ai"};